var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registration" }, [
    _c("div", { staticClass: "registration__head" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "registration__inner" }, [
          _c(
            "div",
            { staticClass: "registration__search" },
            [
              _c("v-text-field", {
                attrs: {
                  placeholder: "Поиск участника",
                  flat: "",
                  solo: "",
                  "hide-details": "",
                  "prepend-icon": "mdi-magnify",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "registration__registered" }, [
            _vm._v(
              "\n          Зарегистрировано " +
                _vm._s(_vm.registered) +
                " из " +
                _vm._s(_vm.max) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "registration__filter" }, [
            _c(
              "button",
              {
                staticClass: "registration__button",
                on: { click: _vm.sort_status },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("span", {
                    staticClass: "big",
                    style: _vm.status_switcher
                      ? { width: "6px" }
                      : { width: "16px" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "middle" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "small",
                    style: _vm.status_switcher
                      ? { width: "16px" }
                      : { width: "6px" },
                  }),
                ]),
                _vm._v("\n            статус\n          "),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "registration__button",
                on: { click: _vm.sort_name },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("span", {
                    staticClass: "big",
                    style: _vm.name_switcher
                      ? { width: "6px" }
                      : { width: "16px" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "middle" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "small",
                    style: _vm.name_switcher
                      ? { width: "16px" }
                      : { width: "6px" },
                  }),
                ]),
                _vm._v("\n            фамилия\n          "),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "registration__body" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "ul",
          { staticClass: "registration__list" },
          _vm._l(_vm.users, function (user, index) {
            return _c(
              "li",
              { key: index, staticClass: "registration__item" },
              [
                _c(
                  "div",
                  {
                    staticClass: "registration__box",
                    on: {
                      click: function ($event) {
                        return _vm.open_modal(user)
                      },
                    },
                  },
                  [
                    _c("div", {
                      class: user.status
                        ? "registration__cb registration__cb--active"
                        : "registration__cb",
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "registration__values" }, [
                      user.tabel
                        ? _c("span", { staticClass: "registration__table" }, [
                            _vm._v("Стол " + _vm._s(user.tabel)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "registration__name" }, [
                        _vm._v(_vm._s(user.name)),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("v-textarea", {
                  staticClass: "registration__text_textarea",
                  attrs: {
                    required: "",
                    solo: "",
                    id: "message",
                    "no-resize": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n                      Комментарий\n                      " +
                                _vm._s(user.comment) +
                                "\n                    "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: user.comment,
                    callback: function ($$v) {
                      _vm.$set(user, "comment", $$v)
                    },
                    expression: "user.comment",
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn_red px-3 py-2",
                    on: {
                      click: function ($event) {
                        return _vm.sendMessage(user)
                      },
                    },
                  },
                  [_vm._v("Сохранить комментарий")]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.modal
      ? _c("div", { staticClass: "registration__modal" }, [
          _c("div", { staticClass: "inner" }, [
            _c(
              "button",
              {
                staticClass: "close",
                on: {
                  click: function ($event) {
                    return _vm.close_modal(_vm.active_user)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      stroke: "inherit",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M18 6L6 18",
                        stroke: "inherit",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M6 6L18 18",
                        stroke: "inherit",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "icon" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "41",
                    height: "40",
                    viewBox: "0 0 41 40",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M33.8337 35V31.6667C33.8337 29.8986 33.1313 28.2029 31.881 26.9526C30.6308 25.7024 28.9351 25 27.167 25H13.8337C12.0655 25 10.3699 25.7024 9.11961 26.9526C7.86937 28.2029 7.16699 29.8986 7.16699 31.6667V35",
                      stroke: "#inherit",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M20.4997 18.3333C24.1816 18.3333 27.1663 15.3486 27.1663 11.6667C27.1663 7.98477 24.1816 5 20.4997 5C16.8178 5 13.833 7.98477 13.833 11.6667C13.833 15.3486 16.8178 18.3333 20.4997 18.3333Z",
                      stroke: "inherit",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("span", { staticClass: "registration__name" }, [
                _vm._v(_vm._s(_vm.active_user.name)),
              ]),
              _vm._v(" "),
              _vm.active_user.tabel
                ? _c("span", { staticClass: "registration__table" }, [
                    _vm._v("Стол " + _vm._s(_vm.active_user.tabel)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.active_user.status
              ? _c(
                  "button",
                  {
                    staticClass: "button button-unregister",
                    on: {
                      click: function ($event) {
                        return _vm.unregister_user(_vm.active_user)
                      },
                    },
                  },
                  [_vm._v("Отменить регистрацию")]
                )
              : _c(
                  "button",
                  {
                    staticClass: "button button-register",
                    on: {
                      click: function ($event) {
                        return _vm.register_user(_vm.active_user)
                      },
                    },
                  },
                  [_vm._v("Зарегистрировать")]
                ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }